module.exports = __webpack_public_path__ + "img/ic30Contract.da7fcacd.svg";